import { createStore } from "vuex";
import baseUrl from '../service/urls';

export default createStore({
    state: {
        userData: {},
        baseUrl: baseUrl,
        uploadHeaders: {
            Authorization: 'Bearer ' + window.localStorage.getItem('_TOKEN_')
        },
        institutionNatureList: [
            { id: "1", name: 'VC' },
            { id: "2", name: 'PE' },
            { id: "3", name: 'VC-PE' },
            { id: "4", name: '天使投资' },
            { id: "5", name: '券商直投' },
            { id: "6", name: '战略投资' },
            { id: "7", name: '母基金' },
            { id: "8", name: '产业资本' },
            { id: "9", name: '债权' }
        ], // 机构性质
        investmentFiledList: [
            { id: "1", name: '企业服务' },
            { id: "2", name: '电子商务' },
            { id: "3", name: '文化娱乐' },
            { id: "4", name: '金融' },
            { id: "5", name: '医疗健康' },
            { id: "6", name: '硬件' },
            { id: "7", name: '汽车交通' },
            { id: "8", name: '教育' },
            { id: "9", name: '游戏' },
            { id: "10", name: '本地生活' },
            { id: "11", name: '工具软件' },
            { id: "12", name: '旅游' },
            { id: "13", name: '社交网络' },
            { id: "14", name: '广告营销' },
            { id: "15", name: '互联网' },
            { id: "16", name: '生活服务' },
            { id: "17", name: '房产服务' },
            { id: "18", name: '房产家居' },
            { id: "19", name: 'IT' },
            { id: "20", name: '移动互联网' },
            { id: "21", name: '高新科技' },
            { id: "22", name: '物流' },
            { id: "23", name: '消费' },
            { id: "24", name: '人工智能' },
            { id: "25", name: '体育' },
            { id: "26", name: '生物技术/医疗健康' },
            { id: "27", name: '其他行业' },
            { id: "28", name: '体育运动' },
            { id: "29", name: '虚拟现实' },
            { id: "30", name: '信息技术' },
            { id: "31", name: '教育培训' },
            { id: "32", name: '社交' },
            { id: "33", name: '交通能源' },
            { id: "34", name: '媒体营销' },
            { id: "35", name: '生产制造' },
            { id: "36", name: '快递物流' },
            { id: "37", name: '物流商贸' },
            { id: "38", name: '生物科技' },
            { id: "39", name: '软件' },
            { id: "40", name: '体育健身' },
            { id: "41", name: '文体娱乐' },
            { id: "42", name: '汽车服务' },
            { id: "43", name: '新材料' },
            { id: "44", name: '餐饮酒店' },
            { id: "45", name: '电信及增值业务' },
            { id: "46", name: '金融支付' },
            { id: "47", name: '农牧渔林' },
            { id: "48", name: '旅游户外' },
            { id: "49", name: '连锁及零售' },
            { id: "50", name: '传统制造' },
            { id: "51", name: '建筑地产' },
            { id: "52", name: '物流运输' },
            { id: "53", name: '电商' },
            { id: "54", name: '娱乐传媒' },
            { id: "55", name: '教育与培训' },
            { id: "56", name: 'VR/AR' },
            { id: "57", name: '社交社区' },
            { id: "58", name: '机械制造' },
            { id: "59", name: '电子及光电设备' },
            { id: "60", name: '农业' },
            { id: "61", name: '公共事业' },
            { id: "62", name: '汽车' },
            { id: "63", name: '先进制造' },
            { id: "64", name: '半导体' },
            { id: "65", name: '智能硬件' },
            { id: "66", name: '家居装修' },
            { id: "67", name: '化工原料及加工' },
            { id: "68", name: '餐饮业' },
            { id: "69", name: '清洁技术' },
            { id: "70", name: '家电数码' },
            { id: "71", name: '房地产' },
            { id: "72", name: '大数据' },
            { id: "73", name: '零售贸易' },
            { id: "74", name: '跨界服务' },
            { id: "75", name: '其他' },
            { id: "76", name: '科研及技术服务' },
            { id: "77", name: '农/林/牧/渔' },
            { id: "78", name: 'O2O' },
            { id: "79", name: '建筑/工程' },
            { id: "80", name: '批发零售' },
            { id: "81", name: '能源及矿产' },
            { id: "82", name: '纺织及服装' },
            { id: "83", name: '通信' },
            { id: "84", name: '区块链' },
            { id: "85", name: '食品&饮料' },
            { id: "86", name: '建筑' },
            { id: "87", name: '生活服务' },
            { id: "88", name: '广播电视及数字电视' },
            { id: "89", name: '服装纺织' },
            { id: "90", name: '媒体出版' },
            { id: "91", name: '媒体' },
            { id: "92", name: '建筑业' },
            { id: "93", name: '宠物' },
            { id: "94", name: '农林牧渔' },
            { id: "95", name: '消费升级' },
            { id: "96", name: '能源电力' },
            { id: "97", name: '食品饮料' },
            { id: "98", name: '食品餐饮' },
            { id: "99", name: '生活家居' },
            { id: "100", name: '环保' }
        ], // 投资领域
        cityList: [
            { id: "1", name: '北京' },
            { id: "2", name: '上海' },
            { id: "3", name: '广州' },
            { id: "4", name: '深圳' },
            { id: "5", name: '香港' },
            { id: "6", name: '台湾' },
            { id: "7", name: '海外' },
            { id: "8", name: '天津' },
            { id: "9", name: '杭州' },
            { id: "10", name: '苏州' },
            { id: "11", name: '南京' },
            { id: "12", name: '重庆' },
            { id: "13", name: '成都' },
            { id: "14", name: '武汉' },
            { id: "15", name: '西安' },
            { id: "16", name: '郑州' },
            { id: "17", name: '大连' },
            { id: "18", name: '沈阳' },
            { id: "19", name: '长沙' },
            { id: "20", name: '青岛' },
            { id: "21", name: '安徽' },
            { id: "22", name: '澳门' },
            { id: "23", name: '福建' },
            { id: "24", name: '甘肃' },
            { id: "25", name: '广东' },
            { id: "26", name: '广西' },
            { id: "27", name: '贵州' },
            { id: "28", name: '海南' },
            { id: "29", name: '河北' },
            { id: "30", name: '河南' },
            { id: "31", name: '黑龙江' },
            { id: "32", name: '湖北' },
            { id: "33", name: '湖南' },
            { id: "34", name: '吉林' },
            { id: "35", name: '江苏' },
            { id: "36", name: '江西' },
            { id: "37", name: '辽宁' },
            { id: "38", name: '内蒙古' },
            { id: "39", name: '宁夏' },
            { id: "40", name: '青海' },
            { id: "41", name: '山东' },
            { id: "42", name: '山西' },
            { id: "43", name: '陕西' },
            { id: "44", name: '四川' },
            { id: "45", name: '西藏' },
            { id: "46", name: '新疆' },
            { id: "47", name: '云南' },
            { id: "48", name: '浙江' }
        ],
        institutionTypeList: [
            { label: '有限公司', value: '1' },
            { label: '股份公司', value: '2' },
            { label: '个人独资企业', value: '3' },
            { label: '一人有限公司', value: '4' },
            { label: '国有企业', value: '5' },
            { label: '外资企业', value: '6' },
            { label: '中外合资企业', value: '7' },
            { label: '其他', value: '8' },
        ], // 机构类型
        scaleList: [
            { label: '双创板（100万＜规模范围≤500万）', value: '1' },
            { label: '加速板（500万＜规模范围≤2000万）', value: '2' },
            { label: '规上板（2000万＜规模范围≤1亿）', value: '3' },
            { label: '红筹板（1亿以上）', value: '4' },
            { label: '股改板', value: '5' }
        ], // 规模
    },
    getters: {},
    mutations: {
        $changeStore(state: any, data: any) {
            // console.log('$changeStore>>>', data);
            state[data.key] = data.value;
            window.sessionStorage.setItem('_USER_DATA_', JSON.stringify(data.value));
        }
    },
    actions: {},
    modules: {},
});
